<div [ngClass]="'title-header'" [class.kyc]="isKyc" [ngStyle]="marginTop ? {'margin-top': marginTop } : ''" [class.emiHelp]="emihelpText">
	<zest-order-banner [showOrderBanner]="showOrderBanner" [message]="message" [showMerchantLogo]="showMerchantLogo" [merchantName]="merchantName"
	 [basketAmount]="basketAmount" [emi]="emi"></zest-order-banner>
	<div class="title-page text-center">
		<div [ngClass]="additionalClass ? additionalClass : ''">
			<h5 class="title-main" *ngIf="mainTitle" [innerHTML]="mainTitle | safeHtml"></h5>
			<p class="small-note center" *ngIf="smallNote" [innerHTML]="smallNote | safeHtml"></p>
			<!-- <div class="profile-pic" *ngIf="headerPic" [ngStyle]="{'background-image': 'url(' + headerPic + ')'}"></div> -->
			<a *ngIf="tooltip" class="tooltipped btn-floating btn-flat" materialize="tooltip" [materializeParams]="[{html: true, tooltip: tooltip}]"
			 data-position="left bottom" data-delay="50">
				<span>?</span>
			</a>
			<a *ngIf="modal" class="tooltipped btn-floating btn-flat" data-position="left bottom" data-delay="50" (click)="showModal()">
				<span>?</span>
			</a>
		</div>
	</div>
	<div class="lender-note" *ngIf="lenderDetailText && lenderDetailText.length > 0">
		<p class="lendermsg" [innerHTML]="lenderDetailText | safeHtml"></p>
	</div>
	<div class="download-button" *ngIf="downloadButtontext && downloadButtontext.length > 0"><i class="material-icons download-icon">file_download</i><a href="#" class="download-sanction-letter" [innerHTML]="downloadButtontext | safeHtml" (click)="startSanctionLetterDownload($event)"></a></div>
	<div class="disbursal-compliance" *ngIf="disbursalCompliance && disbursalCompliance.length > 0" [innerHTML]="disbursalCompliance | safeHtml">
	</div>
	<div class="in-principle-note" *ngIf="inPrincipleText && inPrincipleText.length > 0">
		<p class="inprinciplemsg" [innerHTML]="inPrincipleText | safeHtml"></p>
	</div>
	<div class="giftcard-note" *ngIf="helpText && helpText.length > 0">
		<p class="msg" [innerHTML]="helpText | safeHtml"></p>
  </div>
  <div class="giftcard-note" *ngIf="repaymentText && repaymentText.length > 0">
		<p class="repaymentmsg" [innerHTML]="repaymentText | safeHtml"></p>
  </div>
  <div class="information-note" *ngIf="info && info.length > 0">
		<p><img src="../../../assets/images/info.svg" class = "information-img"><span class="msg"> {{ info}}</span></p>
	</div>
	<div class="emidate-note" *ngIf="emihelpText">
		<p><img src="../../../assets/images/info.svg" class = "info-img"> <span class = "repaymentday-desc"> {{ emihelpText }} </span></p>
	</div>
</div>
<div *ngIf="modal" id="headerModal" class="modal" materialize="modal" [materializeParams]="[{dismissible: true, complete: dismiss}]">
	<div class="modal-content text-left">
		<span class="close-button" (click)="closeModal()"> x </span>
		<div [innerHTML]="modal | safeHtml"></div>
	</div>
</div>
